import * as React from 'react';
import { Steps as OSteps, Gap } from '@osui/ui';
import { scrollIntoView, formValidate } from '../../utils';
import { useFormInstance } from '../../hooks';
import { stepContext } from './stepContext';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

// 用来控制step的状态
function useStep(props) {
  var _props$current;

  const form = useFormInstance();
  const [step, setStep] = React.useState((_props$current = props.current) !== null && _props$current !== void 0 ? _props$current : 0);
  const isLast = step === props.steps.length - 1;
  React.useEffect(() => {
    if (props.current == null) {
      return;
    }

    setStep(props.current); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.current]);
  const nextStep = React.useCallback(() => {
    formValidate(form).then(() => {
      setStep(s => s + 1);
    }).catch(e => {
      // eslint-disable-next-line no-console
      console.log(e);
      scrollIntoView();
    });
  }, [form]);
  const prevStep = React.useCallback(() => {
    form.clearErrors();
    setStep(s => s - 1);
  }, [form]);
  return {
    nextStep,
    prevStep,
    step,
    setStep,
    isLast
  };
} // 这个组件还是保持了旧的api，没有用antd-com里的封装。官方的那个step-form里，状态同步看着就是完全的事件广播，一点都不react


function InnerStep(props) {
  const {
    steps,
    children,
    className,
    ...restProps
  } = props;
  const {
    step,
    isLast,
    nextStep,
    prevStep,
    setStep
  } = useStep(props);
  const value = React.useMemo(() => {
    return {
      step,
      isLast,
      nextStep,
      prevStep,
      setStep
    };
  }, [isLast, nextStep, prevStep, setStep, step]);
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsxs(stepContext.Provider, {
      value: value,
      children: [/*#__PURE__*/_jsx(OSteps, { ...restProps,
        current: step,
        children: steps.map(s => {
          return /*#__PURE__*/_createElement(OSteps.Step, { ...s,
            key: s.title
          });
        })
      }), /*#__PURE__*/_jsx(Gap, {
        orientation: "vertical",
        factor: 5
      }), children]
    })
  });
}

InnerStep.displayName = "InnerStep";
export const Step = InnerStep;
//# sourceMappingURL=es/FormUI/Step/Step.js.map